import { IWizardStep } from "../../../../../wizard/types";
import validator from "../../validators/step4/validator";
import Content from "./Content";

export const createConfigStep4: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add program",
  },
  content: Content,
  validator: validator,
  stepName: "step4",
};
